<template>
	<slick ref="slick" :options="slickOptions">
		<div class="company-item-container" v-for="item in slides" :key="`company-slider-item-${item.id}`">
			<div class="company-item">
				<router-link :to="{ name: 'single-destination', params: { uuid: item.id } }" class="thumbnail-container" :style="{ backgroundImage: `url(${$options.filters.imageproxy(item.image_url,400)})` }">
					<img :src="$options.filters.imageproxy(item.image_url,400)" :alt="`${item.title} - Thumbnail`" class="show-for-sr">
				</router-link>
				<router-link :to="{ name: 'single-destination', params: { uuid: item.id } }" class="company-title">
					{{ item.title }}
				</router-link>
				<div class="meta-infos">
					<span class="distance" v-if="item.distance">
						<font-awesome-icon :icon="['far', 'location-arrow']" />
						{{ (item.distance/1000).toFixed(0) + ' km' }}
					</span>
					<span class="likes" v-if="item.likes >= 0">
						<font-awesome-icon :icon="['far', 'thumbs-up']" />
						{{ item.likes }}
					</span>
				</div>
			</div>
		</div>
	</slick>
</template>

<script>
	import Slick from 'vue-slick'

	export default {
		name: 'CompanySlider',
		components: {
			Slick
		},
		props: {
			limit: {
				type: Number,
				default: 10
			},
			items: {
				type: Array,
				default () {
					return []
				}
			}
		},
		computed: {
			slides() {
				if (this.items.length > this.limit) {
					return this.items.slice(0, this.limit)
				}

				return this.items
			}
		},
		data () {
			return {
				slickOptions: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: false,
					arrows: false,
					dots: false,
					rows: false
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.slick-track{
		display: flex !important;
		align-items: stretch;
		justify-content: center;

		.slick-slide{
			height: auto;
		}
	}

	.slick-slider{
		@include flex();
		width: 100%;

		.company-item-container{
			width: 40vw !important;
			margin: .5rem;
			padding: map-get($grid-padding-gutters, small) / 2;
			border-radius: 3px;
			box-shadow: 0px 0px 2px rgba($black, .25);

			&:first-child{
				margin-left: 2px;
			}

			.company-item{
				display: flex;
				flex-wrap: wrap;
				flex-direction: column;

				width: 100%;
				height: 100%;
				.thumbnail-container{
					display: block;
					min-height: rem-calc(100);
					border-radius: 3px;
					background-size: cover;
					background-position: center center;
					background-repeat: no-repeat;
				}
				.company-title{
					display: block;
					margin-top: .25rem;
					margin-bottom: rem-calc(30);
					font-weight: bold;
					line-height: 1.2;

				}
				.meta-infos{
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-top: auto;
					color: $medium-gray;
				}
			}
		}
	}
</style>